import React, { PureComponent, PropTypes } from 'react';
import jack from 'jack-logs';

import './styles.scss';

// Still not happy with this -> I feel like it could be pure if we put some more thought in

export class SettingsUpdating extends PureComponent {
  componentDidMount() {
    jack.dev.log({ message: 'Force Update Started' });
    if (window.forceUpdate) {
      window.forceUpdate()
        .catch(() => this.props.cancel());
    } else {
      setTimeout(() => window.location.reload(), 1000);
    }
  }

  render() {
    return (
      <div className='settings-updating'>
        <div className='settings-updating-modal'>
          <i className='fa fa-circle-o-notch fa-spin fa-4x fa-fw' aria-hidden='true' />
          <h3>Update in progress</h3>
          <p>The page will refresh when the update is complete</p>
        </div>
      </div>
    );
  }
}

SettingsUpdating.propTypes = {
  cancel: PropTypes.func,
};

export default SettingsUpdating;



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/settings/SettingsUpdating/main.jsx